import React from "react"

import Task from "../../model2/task/task"
import ModalMoveTo from "../move-to/components/modal"
import {ModalMoveTo_Type} from "../move-to/@const"
import {AddToProject_Manager} from "./model/manager"

type ModalAddToProject_Params = {
    callback?           : callback
    toggleCallback?     : {(isModalOpen: boolean): void}
}

function modalAddProject(manager: AddToProject_Manager, params?: ModalAddToProject_Params) {
    gd.modal.showV5(
        <ModalMoveTo manager={manager} />,
        {
            toggleCallback: params?.toggleCallback
        }
    )
}

export function modalAddTaskToProject(task:Task, params?: ModalAddToProject_Params) {
    const manager = new AddToProject_Manager(ModalMoveTo_Type.TASK)
    manager.tasksToMove         = [task]
    manager.originalProjectId   = task.project?.treeParent?.id
    manager.targetProject       = task.project?.treeParent || undefined
    manager.targetWorkspace     = task.project?.workspace || undefined

    manager.callback            = params?.callback

    modalAddProject(manager, params)
}